class Character {
	constructor(id, slug, power, completionMsg) {
		this.id = id;
		this.slug = slug;
		this.power = power;
		this.completionMsg = completionMsg;
	}

	toPlainObj() {
		return {
			id: this.id,
			slug: this.slug,
			power: this.power.toPlainObj(),
			completionMsg: this.completionMsg
		};
	}
}

export default function CharacterBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withSlug: function (slug) {
			this.slug = slug;
			return this;
		},
		withPower: function (power) {
			this.power = power;
			return this;
		},
		withCompletionMsg: function (completionMsg) {
			this.completionMsg = completionMsg;
			return this;
		},
		build: function () {
			return new Character(this.id, this.slug, this.power, this.completionMsg);
		}
	};
}
